import { type service } from "@repo/api";
import { Button, ListView, ListViewItem } from "@repo/skapa";
import { t } from "@repo/translation";
import { ModalSheet, translateServices, useOrderedServices } from "@repo/ui";
import { useState } from "react";

interface Props {
  isOpen: boolean;
  closeModal: () => void;
  services?: service[];
  onSave: (services: service[]) => Promise<void>;
}

export const ServiceInterestedInModal = ({
  isOpen,
  closeModal,
  services,
  onSave,
}: Props) => {
  const servicesList = useOrderedServices();
  const [selected, setSelected] = useState<service[]>(services ?? []);
  const [isUpdating, setIsUpdating] = useState<boolean>(false);

  const onChange = (checked: boolean, value: service) => {
    setSelected(
      checked ? [...selected, value] : selected.filter((item) => item !== value)
    );
  };

  return (
    <ModalSheet
      title={t("label.services_interested")}
      visible={isOpen}
      onClose={closeModal}
      onBack={closeModal}
      footer={
        <Button
          text={t("action.save")}
          type="primary"
          onClick={() => {
            setIsUpdating(true);
            onSave(selected).finally(() => {
              setIsUpdating(false);
              closeModal();
            });
          }}
          loading={isUpdating}
        />
      }
    >
      <ListView id="services-interested-select">
        {servicesList.map((el) => (
          <ListViewItem
            key={el[0]}
            title={translateServices(el[1]) ?? "-"}
            control="checkbox"
            emphasised={false}
            controlProps={
              {
                value: el[0],
                defaultChecked: Boolean(
                  services?.find((item: service) => item === el[0])
                ),
                onChange: (e: any) => onChange(e.target.checked, el[0]),
              } as any
            }
          />
        ))}
      </ListView>
    </ModalSheet>
  );
};
